<div class="mb-4">
  <button mat-stroked-button type="button" (click)="add()">
    <mat-icon>add</mat-icon>
    {{ 'waters.season-periods.add' | translate }}
  </button>
</div>

@if (rows().length === 0) {
  <p class="text-gray-500 py-4">{{ 'waters.season-periods.empty' | translate }}</p>
} @else {
  <table mat-table [dataSource]="rows()" class="w-full">
    <ng-container matColumnDef="seasonType">
      <th mat-header-cell *matHeaderCellDef>{{ 'waters.season-periods.column.season-type' | translate }}</th>
      <td mat-cell *matCellDef="let row; let i = index">
        <mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-full min-w-48">
          <mat-select
            [value]="row.periodTypeId"
            [placeholder]="'waters.season-periods.select-season' | translate"
            (selectionChange)="setField(i, 'periodTypeId', $event.value)">
            @for (type of codeListsService.periodTypes(); track type.id) {
              <mat-option [value]="type.id">{{ type.name }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </td>
    </ng-container>

    <ng-container matColumnDef="from">
      <th mat-header-cell *matHeaderCellDef>{{ 'waters.season-periods.column.from' | translate }}</th>
      <td mat-cell *matCellDef="let row; let i = index">
        <div class="flex gap-2">
          <mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-28">
            <mat-label>{{ 'waters.season-periods.column.week' | translate }}</mat-label>
            <mat-select [value]="row.fromWeek" (selectionChange)="setField(i, 'fromWeek', $event.value)">
              @for (week of weeks; track week) {
                <mat-option [value]="week">{{ week }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-40">
            <mat-label>{{ 'waters.season-periods.column.day' | translate }}</mat-label>
            <mat-select [value]="row.fromDay" (selectionChange)="setField(i, 'fromDay', $event.value)">
              @for (day of days; track day.value) {
                <mat-option [value]="day.value">{{ 'waters.season-periods.day.' + day.key | translate }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="until">
      <th mat-header-cell *matHeaderCellDef>{{ 'waters.season-periods.column.until' | translate }}</th>
      <td mat-cell *matCellDef="let row; let i = index">
        <div class="flex gap-2">
          <mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-28">
            <mat-label>{{ 'waters.season-periods.column.week' | translate }}</mat-label>
            <mat-select [value]="row.untilWeek" (selectionChange)="setField(i, 'untilWeek', $event.value)">
              @for (week of weeks; track week) {
                <mat-option [value]="week">{{ week }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-40">
            <mat-label>{{ 'waters.season-periods.column.day' | translate }}</mat-label>
            <mat-select [value]="row.untilDay" (selectionChange)="setField(i, 'untilDay', $event.value)">
              @for (day of days; track day.value) {
                <mat-option [value]="day.value">{{ 'waters.season-periods.day.' + day.key | translate }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef class="w-16"></th>
      <td mat-cell *matCellDef="let row; let i = index">
        <button
          mat-icon-button
          type="button"
          color="warn"
          [matTooltip]="'waters.season-periods.delete' | translate"
          (click)="remove(i)">
          <mat-icon>delete</mat-icon>
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
}
